import React from 'react';

// ─── Sort icon ────────────────────────────────────────────────────────────────
export const SortIcon = ({ column, sortKey, sortDir }) => {
    const isActive = column === sortKey;
    return (
        <i
            aria-hidden="true"
            className={[
                'funds-raised-table__sort-icon fa',
                isActive
                    ? `fa-sort-${sortDir === 'asc' ? 'up' : 'down'} funds-raised-table__sort-icon--active`
                    : 'fa-sort',
            ].join(' ')}
        />
    );
};

// ─── Deployment bar cell ──────────────────────────────────────────────────────
export const DeploymentCell = ({ pct, color, isEstimated }) => {
    if (pct == null) {
        return <span className="funds-raised-table__empty">–</span>;
    }
    return (
        <div className="fr-deployment-cell">
            <div className="fr-deployment-cell__track">
                <div
                    className={`fr-deployment-cell__fill fr-deployment-cell__fill--${color}`}
                    style={{ width: `${Math.min(pct, 100)}%` }}
                />
            </div>
            <span className={`fr-deployment-cell__pct${isEstimated ? ' amount--estimated' : ''}`}>{pct}%</span>
        </div>
    );
};

// ─── Status badges cell ───────────────────────────────────────────────────────
export const StatusCell = ({ badges = [] }) => {
    if (!badges.length) return <span className="funds-raised-table__empty">–</span>;
    return (
        <div className="fr-status-cell">
            {badges.map((badge, i) => (
                <span key={i} className={`fr-status-badge fr-status-badge--${badge.variant}`}>
                    {badge.label}
                </span>
            ))}
        </div>
    );
};
